var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_6448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.375 6H10.625C10.0016 6 9.5 6.50156 9.5 7.125V7.875C9.5 8.49844 10.0016 9 10.625 9C10.625 13.2656 13.0156 16.8609 16.2875 18C13.0156 19.1391 10.625 22.7344 10.625 27C10.0016 27 9.5 27.5016 9.5 28.125V28.875C9.5 29.4984 10.0016 30 10.625 30H26.375C26.9984 30 27.5 29.4984 27.5 28.875V28.125C27.5 27.5016 26.9984 27 26.375 27C26.375 22.7344 23.9844 19.1391 20.7125 18C23.9844 16.8609 26.375 13.2656 26.375 9C26.9984 9 27.5 8.49844 27.5 7.875V7.125C27.5 6.50156 26.9984 6 26.375 6ZM22.8547 24H14.1453C14.9469 21.8063 16.5875 20.25 18.5 20.25C20.4125 20.25 22.0578 21.8063 22.8547 24ZM22.8547 12H14.1453C13.8125 11.0859 13.625 10.0641 13.625 9H23.375C23.375 10.0688 23.1875 11.0906 22.8547 12Z",
    fill: "#4E26A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_6448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 24,
    fill: "white",
    transform: "translate(9.5 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPHistoryIcon);
export default __webpack_public_path__ + "static/media/p_history_icon.b8ae40d2108125fc272ec9b9c4f9eb6a.svg";
export { ForwardRef as ReactComponent };